import { z } from 'zod';
const MAX_FILE_SIZE = 20 * 1024 * 1024; // 20 MB

const fileSchema = z
  .instanceof(File)
  .refine(file => file.size <= MAX_FILE_SIZE, "Max file size is 20 MB")
  .optional()
  .nullable();
export const blogSchema = z.object({
  title: z
    .string()
    .trim()
    .min(2, 'Title is required.')
    .max(100, 'Title cannot exceed 100 characters.'),

  content: z
    .string()
    .trim(),
  excerpt: z
    .string()
    .trim()
    .max(200, 'Excerpt cannot exceed 200 characters.')
    .optional(),
  image: fileSchema,
  meta_title: z
    .string()
    .trim()
    .max(60, 'Meta title cannot exceed 60 characters.')
    .optional(),
  meta_description: z
    .string()
    .trim()
    .max(160, 'Meta description cannot exceed 160 characters.')
    .optional(),
  status: z
    .enum(['draft', 'published'])
    .optional(),
});

export type BlogFormValues = z.infer<typeof blogSchema>;